import { css } from '@emotion/react';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import dynamic from 'next/dynamic';
import type { LottieProps } from 'react-lottie';

import animationData from '../../../lotties/confettis.json';

const Lottie = dynamic(
  () => import('react-lottie').then((mod) => ({ default: mod.default })),
  { ssr: false }
) as React.ComponentType<LottieProps>;

const defaultOptions = {
  loop: false,
  autoplay: true,
  animationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const style = {
  root: css`
    @keyframes zoom-in {
      0% {
        transform: translate(-50%, -50%) scale(0);
      }
      30% {
        transform: translate(-50%, -50%) scale(1);
      }
      60% {
        transform: translate(-50%, -50%) scale(1);
      }
      100% {
        transform: translate(-50%, -50%) scale(0);
      }
    }
    @keyframes fade-in {
      0% {
        opacity: 0;
      }
      30% {
        opacity: 1;
      }
      60% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }
  `,
};

export const GoalAnimation = ({ teamName }: { teamName: string }) => {
  return (
    <Box
      css={style.root}
      className="goal"
      style={{
        top: '-5rem',
        left: '0',
        position: 'absolute',
        zIndex: 999,
        bottom: '0',
        height: '100vh',
        width: '100vw',
        background: 'white',
        animation: 'fade-in 3s .2s linear',
        opacity: 0,
      }}
    >
      <Typography
        variant="h1"
        style={{
          fontWeight: 'bold',
          position: 'absolute',
          left: '50%',
          top: '45%',
          transform: 'translate(-50%, -50%)',
          animation: 'zoom-in 3s ease-in-out',
          textAlign: 'center',
        }}
        gutterBottom
      >
        Nouveau score pour l'équipe <strong>{teamName} !</strong>
      </Typography>
      <Lottie options={defaultOptions} height="100vh" width="100vw" />
    </Box>
  );
};
